import { ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import Icon from "@mui/material/Icon";

interface Iprops {
  href?: string;
  icon?: any;
  title: string;
  handleMobileDrawerClose: () => void;
  onClick?: () => void; 
}

export const MobileItem = (props: Iprops) => {
  const { href, icon, title, handleMobileDrawerClose } = props;

  const navigate = useNavigate();
  const location = useLocation();

  const active = href ? location.pathname === href : false;

  // const gotoRoute: any = (href: string) => {
  //   navigate(href);
  //   handleMobileDrawerClose();
  // };

  const gotoRoute: any = (href: string) => {
    if (props.onClick) props.onClick(); // ✅ close open menus
    navigate(href);
    handleMobileDrawerClose(); // ✅ close drawer
  };

  return (
    <ListItemButton
      onClick={() => gotoRoute(href)}
      key={title}
      sx={{
        px: 2.5,
        borderRadius: 2,
        color: active ? "primary.main" : undefined,
        bgcolor: active ? "#ccc" : undefined,
        "&:hover": {
          bgcolor: "#ccc",
          color: "primary.contrastText",
        },
      }}
    >
      <ListItemIcon
        sx={{
          minWidth: 0,
          mr: 3,
        }}
      >
        <Icon
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
          }}
        >
          {icon}
        </Icon>
      </ListItemIcon>
      <ListItemText primary={title} />
    </ListItemButton>
  );
};
